export default {
    computed: {
      /**
       * Return the icon string for the activity type
       *
       * @return string
       */
      iconForActivityType () {
        if (this.activity.type === 'milestone') {
          if (this.activity.status === "overdue") {
            return "fa-exclamation"
          } else if (this.activity.status === "delayed") {
            return "fa-exclamation"
          } else {
            return 'fa-bullseye-arrow'
          }
        } else if (this.activity.type === 'meeting') {
          if (this.activity.status === 'cancelled') {
            return 'fa-calendar-times'
          } else if (this.activity.status === 'rescheduled') {
            return 'fa-calendar-exclamation'
          } else {
            return 'fa-calendar-day'
          }
        } else if (this.activity.type === 'mail') {
            return 'fa-envelope'
        } 
        
        return 'fa-comment-alt-lines'
      },

      classForStatus() {
        if (this.activity.status === "delayed" ||  this.activity.status === "cancelled") {
          return "warning"
        } else if (this.activity.status === "overdue" || this.activity.status === "rescheduled") {
          return "danger"
        } else if (this.activity.status === "complete") {
          return "complete"
        }

        return ""
      },

      titleForStatus() {
        if (this.activity.status === 'completed') {
          return 'Completed'
        } else if (this.activity.status === 'rescheduled') {
          return 'Re-Scheduled'
        } else if (this.activity.status === 'delayed') {
          return 'Delayed'
        } else if (this.activity.status === 'pending') {
          return 'Pending'
        } else {
          return 'N/A'
        }
      },

      shouldShowAchievedDateButton () {
        if (this.activity.type === "milestone" && !this.activity.achieved) {
          return true
        }

        return false
      },

      shouldShowDelayButton () {
        if (this.activity.status === "delayed" || this.activity.status === "cancelled" || this.activity.status === "rescheduled" || this.activity.status === "complete") {
          return false
        }

        if (this.activity.type === "meeting") {
          return true
        }
        return false
      },

      shouldShowStatus() {
        if (this.activity.type === "milestone") {
          return false
        }

        return true
      },

      shouldShowDueDate() {
        
        return true
      },

      shouldShowAchievedDate() {
        if (this.activity.type && (this.activity.type === "milestone")) {
            return true
        }
        
        return false
      },

      titleLabelTitle() {
        if (this.activity.type === "milestone") {
          return "Milestone"
        } else if (this.activity.type === "mail") {
          return "Subject"
        }

        return "Title"
      },

      dueDateLabelTitle() {
        if (this.activity.type === "milestone") {
          return "Target Date"
        }

        return "Date"
      },

      achievedDateLabelTitle() {
        if (this.activity.type === "mail") {
          return "Sent"
        }

        return "Achieved Date"
      }
    }
}